import React, { ReactNode } from 'react';

import styled from 'styled-components/macro';

const LayoutWrapper = styled.section`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  @media screen and (max-width: ${({ theme }) => theme.breakpointsPalette.l}) {
    flex-direction: column;
    /* margin: 0 20px; */
    & > div {
      width: 100%;
    }
  }
`;

const LayoutColumnLeft = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  padding: 20px;
`;

const LayoutColumnCenter = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  padding: 20px;
`;

const LayoutColumnRight = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  padding: 20px;
`;

interface ThreeColumnsLayoutOwnProps {
  leftColumn: ReactNode[];
  centerColumn: ReactNode[];
  rightColumn: ReactNode[];
  leftWidth?: number;
  centerWidth?: number;
  rightWidth?: number;
}

const ThreeColumnsLayout = (props: ThreeColumnsLayoutOwnProps) => {
  const { leftColumn, centerColumn, rightColumn, leftWidth = 33, centerWidth = 20, rightWidth = 40 } = props;
  return (
    <LayoutWrapper>
      <LayoutColumnLeft width={leftWidth}>{leftColumn}</LayoutColumnLeft>
      <LayoutColumnCenter width={centerWidth}>{centerColumn}</LayoutColumnCenter>
      <LayoutColumnRight width={rightWidth}>{rightColumn}</LayoutColumnRight>
    </LayoutWrapper>
  );
};

export default ThreeColumnsLayout;
